module.exports = __webpack_public_path__ + "assets/media/segment-logo.2d21a912.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/segment-logo.svg
// module id = 2893
// module chunks = 0